import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { advertiserNav, adminNav, type NavItem } from './nav';
import { useAccess } from '@/features/AccessProvider';

function titleFor(items: NavItem[], pathname: string): string {
  const match = [...items].reverse().find((i) => (i.end ? pathname === i.to : pathname.startsWith(i.to)));
  return match?.label ?? 'Fasto Ads';
}

export function AdvertiserShell() {
  const { pathname } = useLocation();
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar items={advertiserNav} subtitle="Advertiser" />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar title={titleFor(advertiserNav, pathname)} />
        <main className="flex-1 overflow-y-auto bg-background p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function AdminShell() {
  const { pathname } = useLocation();
  const { can, ready, isSuperuser } = useAccess();
  const items = adminNav.filter((i) => !i.slug || isSuperuser || (ready && can(i.slug)));
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar items={items.length ? items : adminNav.slice(0, 1)} subtitle="Admin" />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar title={titleFor(adminNav, pathname)} />
        <main className="flex-1 overflow-y-auto bg-background p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
